import { RouteRecordRaw } from 'vue-router';
import * as CONST from '@/const'

let routes: RouteRecordRaw[] = [
    {
        path: '/printTemplates',
        name: 'printTemplates',
        component: () => import("./views/printTemplates.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User]
        }
    },
    {
        path: '/printTemplates/:identifier',
        name: 'printTemplateDetail',
        component: () => import("./views/printTemplateDetail.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User],
            hideHelpButton: true
        }
    },
];

export default routes;
